import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTelegramX2019Logo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_13145_38113)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16.0067 32.0133C24.8469 32.0133 32.0133 24.8469 32.0133 16.0067C32.0133 7.16643 24.8469 0 16.0067 0C7.16643 0 0 7.16643 0 16.0067C0 24.8469 7.16643 32.0133 16.0067 32.0133Z",
			fill: "#282A33"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.23693 15.8338C11.9017 13.808 15.007 12.4619 16.5664 11.8088C21.0045 9.95624 21.9375 9.63637 22.5372 9.62305C22.6705 9.62305 22.9637 9.6497 23.1636 9.80964C23.3236 9.94291 23.3635 10.1162 23.3902 10.2495C23.4169 10.3827 23.4435 10.6626 23.4169 10.8759C23.177 13.4081 22.1374 19.5522 21.6043 22.3777C21.3777 23.5772 20.9379 23.9771 20.5114 24.017C19.5785 24.097 18.8721 23.404 17.9791 22.8175C16.5664 21.8979 15.78 21.3248 14.4073 20.4185C12.8213 19.379 13.8475 18.8059 14.7538 17.8729C14.9937 17.633 19.0853 13.9013 19.1653 13.5681C19.1786 13.5281 19.1786 13.3682 19.0853 13.2882C18.992 13.2082 18.8588 13.2349 18.7521 13.2615C18.6055 13.2882 16.3665 14.7809 12.0083 17.7263C11.3685 18.1662 10.7954 18.3794 10.2757 18.3661C9.70257 18.3527 8.60969 18.0462 7.78337 17.7796C6.78379 17.4598 5.98412 17.2865 6.05076 16.7268C6.09074 16.4335 6.49057 16.1403 7.23693 15.8338Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13145_38113",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgTelegramX2019Logo;
